import z from "zod";

export const BankAccountSchema = z.object({
  id: z.number().nullable(),
  userId: z.string().nullable(),
  accountHolderType: z.string().nullable(),
  bankAccountName: z.string().nullable(),
  accountType: z.string().nullable(),
  routingNumber: z.string().nullable(),
  accountNumber: z.string().nullable(),
  isActive: z.boolean().default(false).nullable(),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
});

export type BankAccount = z.infer<typeof BankAccountSchema>;

export const BankAccountResponseSchema = z.object({
  bank_details: BankAccountSchema,
  message: z.string().nullable(),
  success: z.boolean(),
});

export type BankAccountResponse = z.infer<typeof BankAccountResponseSchema>;
